import request from '@/utils/request'

export function getList() {
  return request({
    url: 'api/v1/card/getCardProList',
    method: 'get'
  })
}

export function updateCardPro(data) {
  return request({
    url: 'api/v1/card/updateCardPro',
    method: 'post',
    data: data
  })
}

export function getCardProcessList() {
  return request({
    url: 'api/v1/card/getCardProcess',
    method: 'get'
  })
}

export function updateCardProcess(data) {
  return request({
    url: 'api/v1/card/updateCardProcess',
    method: 'post',
    data: data
  })
}

export function delCardProcess(data) {
  return request({
    url: 'api/v1/card/delCardProcess',
    method: 'delete',
    data: data
  })
}

export function getCardGroupList(data) {
  return request({
    url: 'api/v1/card/getCardGroup',
    method: 'post',
    data: data
  })
}

export function updateCardGroup(data) {
  return request({
    url: 'api/v1/card/updateCardGroup',
    method: 'post',
    data: data,
    timeout: 5000
  })
}

export function delCardGroup(data) {
  return request({
    url: 'api/v1/card/delCardGroup',
    method: 'delete',
    data: data
  })
}

export function exportCardGroup() {
  return request({
    url: 'api/v1/card/exportCardGroup',
    method: 'get'
  })
}

export function importCardGroup(data) {
  return request({
    url: 'api/v1/card/importCardGroup',
    method: 'post',
    data: data,
    timeout: 10000
  })
}

export function getCardCoefficient(data) {
  return request({
    url: 'api/v1/card/getCardCoefficientList',
    method: 'post',
    data: data
  })
}

export function updateCardCoefficientList(data) {
  return request({
    url: 'api/v1/card/updateCardCoefficientList',
    method: 'post',
    data: data
  })
}

export function makeCardGroupJson() {
  return request({
    url: 'api/v1/card/makeJson',
    method: 'get'
  })
}

export function ossSyncGroupJson(data) {
  return request({
    url: 'api/v1/card/syncOssCardGroup',
    method: 'post',
    data: data
  })
}
